import React from 'react';

import Table from '../../components/CherryPicks/Table/Table';

function CherryPicksView() {
  return <Table />;
}

export default CherryPicksView;
